import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
               selector: 'app-input-field',
               templateUrl: './input-field.component.html',
               styleUrls: [ './input-field.component.css' ]
           })
export class InputFieldComponent implements OnInit {

    @Input() data: string;
    @Output() dataChange = new EventEmitter<string>();

    _errors: string[];
    @Input() label: string;
    @Input() type = 'text';
    @Input() placeholder = '';
    @Input() hint: string;
    @Input() comment: string;
    @Input() _min = null;
    @Input() _max = null;

    inputStyleClass = 'form-control';

    constructor() {
    }

    @Input()
    set min(min) {
        this._min = min;
    }

    @Input()
    set max(max) {
        this._max = max;
    }

    @Input()
    set errors(errors) {
        this._errors = errors;
        if (this._errors) {
            this.inputStyleClass = 'form-control is-invalid';
        } else {
            this.inputStyleClass = 'form-control';
        }
    }

    ngOnInit() {
    }

    change($event) {
        if (this.type !== 'file') {
            this.data = $event.target.value;
        } else {
            this.dataChange.emit($event.srcElement.files);
        }
    }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/input-field/input-field.component.ts